import clsx from "clsx";
import { AccountCardProps } from "./AccountCard.types";
import AccountCardDetail from "./AccountCardDetail";
import { Col, useModal } from "@commonlibs";
import { AccountCardRoot, QRColRoot, QrButton, WalletColRoot } from "./AccountCard.styles";
import QRCodeImage from "../../../assets/images/qr-code.png";
import WalletImage from "../../../assets/images/wallet.png";
import PayModal from "ui/transactions/containers/PayModal/PayModal";

function AccountCard({ className, ...rest }: AccountCardProps) {
    const { showModal } = useModal();

    function handleQRClick() {
        showModal(PayModal);
    }
    return (
        <AccountCardRoot className={clsx("base-wallet-card", className)} {...rest}>
            <WalletColRoot>
                <img data-testid="wallet-image" alt="wallet-image" src={WalletImage} width={35} />
            </WalletColRoot>
            <Col style={{ marginLeft: 10 }}>
                <AccountCardDetail />
            </Col>
            <QRColRoot>
                <QrButton onClick={() => handleQRClick()}>
                    <img src={QRCodeImage} alt="qr-button" />
                </QrButton>
            </QRColRoot>
        </AccountCardRoot>
    );
}

export default AccountCard;
